import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import {CONSTANTS} from '../ZoomImage.utils';
import {ZoomContext} from '../index';

/**
 * Canvas:
 *  - The container component on which the image is to be rendered.
 */

export function Canvas(props) {
  const {onImageLoaded, state} = React.useContext(ZoomContext);
  
  const onLoaded = () => onImageLoaded();

  return (
    <div className='canvasWrapper'>
      <div id={CONSTANTS.IMAGE_CONTAINER} className='canvasImage'>
        <img
          id={CONSTANTS.ZOOM_IMAGE}
          src={props.url}
          alt={props.title}
          width={`${state.currentImageSize.width}px`}
          height={`auto`}
          draggable='false'
          onLoad={onLoaded}
        />
      </div>
      {props.children}
    </div>
  );
}

Canvas.propTypes = {
  /**
   * Url for the image to be rendered
   */
  url: PropTypes.string.isRequired,
  /**
   * Title of image to set as alternate text for image.
   */
  title: PropTypes.string.isRequired,
  /**
   * The contol components for the ZoomOperation
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};
